/* eslint-disable */
let firstPaymentDefinitionService;
const cloudHost = FRONTEND_IMAGES_HOST;

class FirstPaymentDefinitionService {
    constructor() {
        this.store = null;
        this.model = new Backbone.Model({
            operators: new Backbone.Collection([]),
        });
    }

    setData(firstPaymentDefinitions) {
        this.store = _.map(firstPaymentDefinitions, (firstPaymentDefinition) => ({
            operatorCover: `https://${cloudHost}/photos/operator/${firstPaymentDefinition.operator}.png`,
            ...firstPaymentDefinition,
        }));

        const collection = new Backbone.Collection(this.store);
        this.model.set('operators', collection);
    }

    getModelData() {
        return this.model;
    }

    getData() {
        return this.model.get('operators')?.toJSON() || [];
    }
}

firstPaymentDefinitionService = firstPaymentDefinitionService || new FirstPaymentDefinitionService();

export default firstPaymentDefinitionService;
